// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"149":"3216a1cf","294":"31d6cfe0","356":"39fa200c"}[chunkId] + ".chunk.css";
};